// Desktop vs mobile UI switch.
//
// Convention: every page keeps its LOGIC in a shared hook and ships two separate
// UI files — `<Page>.desktop.jsx` and `<Page>.mobile.jsx`. The page's index picks
// one with `choose()`. See CLAUDE.md → "Desktop / mobile UI split".
//
// The mobile UI is used by the installed APK **and by a phone browser** (most
// people open the site without installing anything), so the switch is: native
// shell, or a viewport narrower than MOBILE_MAX_WIDTH. Evaluated once at module
// load — a desktop browser resized narrow keeps the desktop UI until reload,
// which is what we want (no remounting the whole app mid-use).
import { isNativeApp } from './deviceIdentity';

export const MOBILE_MAX_WIDTH = 820;

const narrowScreen = () => {
  try {
    if (typeof window === 'undefined') return false;
    if (window.matchMedia) return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
    return window.innerWidth <= MOBILE_MAX_WIDTH;
  } catch { return false; }
};

// True inside the Android APK, or in any browser on a phone-sized screen.
export const isMobileUI = () => isNativeApp() || narrowScreen();

// Pick a component for the current platform: choose(DesktopComp, MobileComp).
// Called at import time by each page's index, so it is stable for the session.
export const choose = (desktop, mobile) => (isMobileUI() ? mobile : desktop);
